import { notification } from 'antd';
import randomId from '../../../../../logic/utils/randomId';
import zoneStore, { updateZoneStore } from '../CurrentZone/Store';
import defaultValues from './defaultValues';
import api from './api';

// Сохранение зоны целиком: оптимистично обновляем стор, при ошибке возвращаем прежнее состояние.
export async function saveZone(nextScreens, successMessage) {
  const prevState = zoneStore.getRawState();
  const nextState = {
    ...prevState,
    config: { ...prevState.config, screens: nextScreens },
  };

  updateZoneStore(nextState);

  // api.updateZone удаляет id из переданного объекта, поэтому отдаём копию
  const res = await api.updateZone({ ...nextState });

  if (res.status) {
    notification.success({ message: successMessage });
    return true;
  }

  updateZoneStore(prevState);
  notification.error({ message: res.errMessage });
  return false;
}

export const getScreens = () => zoneStore.getRawState().config.screens;

export const replaceScreen = (screens, screen) => screens
  .map((item) => (item.screenId === screen.screenId ? screen : item));

// Стартовый экран в зоне ровно один
export const applyStartFlag = (screens, screenId) => screens
  .map((item) => ({ ...item, isStart: item.screenId === screenId }));

export const replaceButton = (screens, screenId, button) => screens.map((item) => {
  if (item.screenId !== screenId) return item;
  return {
    ...item,
    buttons: item.buttons.map((btn) => (btn.id === button.id ? button : btn)),
  };
});

export const createScreen = (values) => ({
  ...defaultValues.screen,
  // старый редактор заводит у информационного экрана пустое поле data — держим паритет
  ...(values.type === 'infoScreen' ? { data: '' } : {}),
  ...values,
  screenId: randomId(5),
});

export const createButton = (screen) => ({
  name: `Название ${screen.buttons.length + 1}`,
  size: 'lg',
  path: '',
  extraText: '',
  icon: false,
  params: { name: 'queue', value: 0 },
  id: randomId(5),
  position: screen.buttons.length + 1,
});

export const reorderButtons = (screens, screenId, fromIndex, toIndex) => screens.map((item) => {
  if (item.screenId !== screenId) return item;
  const buttons = [...item.buttons];
  const [moved] = buttons.splice(fromIndex, 1);
  buttons.splice(toIndex, 0, moved);
  return { ...item, buttons: buttons.map((btn, i) => ({ ...btn, position: i + 1 })) };
});

// Все ссылки на удаляемый экран обнуляем, иначе на схеме останутся битые переходы
export const detachLinksTo = (screens, screenId) => screens.map((item) => ({
  ...item,
  screenPath: item.screenPath === screenId ? '' : item.screenPath,
  buttons: (item.buttons || []).map((btn) => (btn.path === screenId ? { ...btn, path: '' } : btn)),
}));

export const removeScreen = (screens, screenId) => detachLinksTo(screens, screenId)
  .filter((item) => item.screenId !== screenId);

export const findScreen = (screens, screenId) => screens
  .find((item) => item.screenId === screenId);

export const findButton = (screens, screenId, buttonId) => (
  findScreen(screens, screenId)?.buttons || []
).find((btn) => btn.id === buttonId);
